export default __webpack_public_path__ + "static/media/operator-e1.2050abcd.png";